const COMPANIES_DATA = {
    "laltechnology": {
        name: "Lal Technology",
        imageName: null,
        location: "Islamabad, Pakistan",
        position: ".NET Developer",
        workDesc: [
            "Developing and maintaining full-stack web applications using ASP.NET MVC and .NET Core.",
            "Building RESTful Web APIs with C# and Entity Framework for scalable backend services.",
            "Designing and optimizing SQL Server databases with normalized schemas.",
            "Implementing secure coding practices including authentication, authorization, and input validation.",
            "Collaborating with the team using Git/GitHub for version control and code reviews."
        ],
        timePeriod: "03/2026 – Current"
    },
    "proximo": {
        name: "Proximo",
        imageName: null,
        location: "Dera Ismail Khan, Pakistan",
        position: "AWS Developer",
        workDesc: [
            "Designed and deployed cloud infrastructure on Amazon Web Services (AWS).",
            "Worked with AWS services including EC2, S3, RDS, Lambda, and IAM for secure access.",
            "Implemented scalable cloud solutions following AWS best practices.",
            "Monitored and optimized cloud resources for performance and cost efficiency."
        ],
        timePeriod: "04/2024 – 11/2025"
    }
};

export default COMPANIES_DATA;
